import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '@/assets.app/images/empty_listing_block.svg'
import _imports_1 from '@/assets.app/images/empty_listing_block_dark.svg'


const _hoisted_1 = { class: "empty-listing" }
const _hoisted_2 = {
  key: 0,
  class: "empty-listing__img empty-listing__img--light",
  src: _imports_0
}
const _hoisted_3 = {
  key: 1,
  class: "empty-listing__img empty-listing__img--dark",
  src: _imports_1
}

import ListingBlockHeader from '@/app/components/listing/ListingBlockHeader.vue'

/**
 * Empty state for listing blocks.
 *
 * Adds the listing title and a background the wrapped elements.
 *
 * @param title - The title of the listing block.
 * @param useDefaultImage - Whether or not to use the default empty listing image at the top of the block.
 */


export default /*@__PURE__*/_defineComponent({
  __name: 'EmptyListingBlock',
  props: {
    title: {},
    useDefaultImage: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createBlock(ListingBlockHeader, {
          key: 0,
          title: __props.title
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["empty-listing__inner", { 'empty-listing__inner--default': __props.useDefaultImage }])
    }, [
      (__props.useDefaultImage)
        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
        : _createCommentVNode("", true),
      (__props.useDefaultImage)
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}
}

})